import { apiAxiosCMS } from 'services/api';
import { MenuItemLocationProps } from 'types/MenuItemLocationProps';

export async function deleteItemFromBd(
	dataform: MenuItemLocationProps,
	handleNotify: any
) {
	let resp = false;

	await apiAxiosCMS
		.delete(`menu-items-location/${dataform.id}`)
		.then(() => {
			resp = true;
			handleNotify('Item de menu deletado com sucesso', 'success');
		})
		.catch((error) => {
			resp = false;
			handleNotify(error.message || 'Erro ao deletar item de menu', 'error');
		});

	return resp;
}
